import { useCookies } from "react-cookie";
import Header from "../../Components/Header/Header";
import { useEffect, useState } from "react";
import "../../Students/Students.css";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PeopleList from "../../Components/PeopleList/PeopleList";
import { faCircleExclamation, faDoorOpen, faEllipsis, faEnvelopeOpen, faFlagCheckered, faListOl, faPencilAlt, faPlus, faTrash, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { faCircleCheck, faCircleXmark, faStar, faUser, faEnvelope } from "@fortawesome/free-regular-svg-icons";

const UsersAdmin = ({ data, socket } : { data: any, socket: any }) => {

    const [cookies, setCookie] = useCookies();
    const [users, setUsers] = useState<Array<Object>>([]);
    const navigate = useNavigate();
    // alert(data.userData.type);
    if (!data.userData?.admin) navigate(-1);

    useEffect(() => {
        (async () => {
            const options = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                },
            };

            try {
                const request = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/admin/get-users/${data.userData.userId}`, options);
                const response = await request.json();
                if (response.success) setUsers(response.users);
            } catch (e) {
            }

        })();
    }, []);

    const removeUser = async (userId : string) => {

        const options = {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json"
            }
        };

        try {
            const request = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/admin/remove-user/${data.userData.userId}/${userId}`, options);
            const response = await request.json();

            if (response.success) {
                window.location.reload();
            }
        } catch (e) {
        }
    };

    return (
        <div className="students-container">
            <Header data={data} socket={socket} />

            <h2 className="title">{cookies.language === "en" ? "Users" : "Utilizatori"}</h2>

            <PeopleList
                people={users as any}
                en={cookies?.language === "en"}
                showRole
                emptyText={cookies?.language === "en" ? "No users yet." : "Niciun utilizator deocamdată."}
                onEdit={(p) => navigate(`/edit-user/${p.userId}`)}
                onRemove={(p) => removeUser(p.userId)}
            />

            <div className="add-button" onClick={() => navigate("/create-account")} style={{ opacity: 1, cursor: "pointer" }}>
                <FontAwesomeIcon icon={faPlus} className="add-icon" />
                <p>{cookies?.language === "en" ? "Add user" : "Adauga utilizator"}</p>
            </div>    
          
        </div>
    );
};

export default UsersAdmin;